import React from "react";
import "./Artists.scss";
import data from "../../../static/data/data.json";
import ArtistCube from "../../ArtistCube/ArtistCube";
import Footer from "../../Footer/Footer";
const Artists = () => {
  return (
    <div>
      <div className="artists-text">
        בחרו מהרשימה את השלושה שעשו לכם את השנה
      </div>
      <div className="artists-page">
        {data.Artists.map((artist) => {
          return <ArtistCube artist={artist} key={artist.ID} />;
        })}
      </div>
    </div>
  );
};

export default Artists;
